"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSetCustomFieldActions = exports.buildUpdateActions = void 0;
var Subscription_1 = require("../Subscription");
var isDefined_1 = require("../utils/isDefined");
function buildUpdateActions(changes, original) {
    var actions = Object.keys(changes)
        // Include only object props which we recognize, and narrow the type
        .filter(function (name) {
        return Subscription_1.ILineItemCustomFields.names.includes(name);
    })
        // Include only fields which are actually changing
        .filter(function (name) { return changes[name] !== original[name]; })
        // Remove values only if there is a value to be removed.
        // Don't try to remove if the attribute is not present because CT fails in that case.
        .filter(function (name) { return (0, isDefined_1.isDefined)(changes[name]) || (0, isDefined_1.isDefined)(original[name]); })
        .map(function (name) { return ({
        action: 'setLineItemCustomField',
        lineItemId: original.id,
        name: name,
        value: changes[name], // compensate for CT's incorrect TS declaration of `value?: object`
    }); });
    if (changes.quantity !== undefined &&
        changes.quantity !== original.quantity) {
        actions.push({
            action: 'changeLineItemQuantity',
            lineItemId: original.id,
            quantity: changes.quantity,
        });
    }
    return actions;
}
exports.buildUpdateActions = buildUpdateActions;
function buildSetCustomFieldActions(updated, original) {
    if (original === void 0) { original = {}; }
    var actions = Object.keys(updated)
        // Include only object props which we recognize, and narrow the type
        // Include only fields which are actually changing
        .filter(function (name) { return updated[name] !== original[name]; })
        // Remove values only if there is a value to be removed.
        // Don't try to remove if the attribute is not present because CT fails in that case.
        .filter(function (name) { return (!updated[name] && (0, isDefined_1.isDefined)(original[name])) || updated[name]; })
        .map(function (name) { return ({
        action: 'setCustomField',
        name: name,
        value: updated[name],
    }); });
    return actions;
}
exports.buildSetCustomFieldActions = buildSetCustomFieldActions;
//# sourceMappingURL=buildUpdateActions.js.map